import isEmpty from "../../is-Empty";
import Validator from "validator";

export const AdminResetPasswordValidation = (data) => {
  let errors = {};

  data.number = !isEmpty(data.number) ? data.number : "";
  data.password = !isEmpty(data.password) ? data.password : "";
  data.confirm_password = !isEmpty(data.confirm_password)
    ? data.confirm_password
    : "";

  // if (
  //   !Validator.matches(data.password, new RegExp("^([a-zA-Z0-9@*#]{8,25})$"))
  // ) {
  //   errors.password =
  //     "Password should contain at least one digit one lower case one upper case";
  // }
  if (Validator.isEmpty(data.number)) {
    errors.password = "Number is Required";
  }
  if (!Validator.isLength(data.password, { min: 6, max: 25 })) {
    errors.password =
      "Password minimum 6 characters, 1 lowercase, 1 capital, 1 number";
  }
  if (Validator.isEmpty(data.password)) {
    errors.password = "Password is Required";
  }

  if (!Validator.equals(data.password, data.confirm_password)) {
    errors.confirm_password = "Password does not match";
  }
  if (Validator.isEmpty(data.confirm_password)) {
    errors.confirm_password = "Confirm Password is Required";
  }
  return {
    errors,
    isValid: isEmpty(errors),
  };
};
